import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StyledBlackInformationTypography, StyledNestedTabs } from "../../../../components/commonComponents/StyledComponents/styled";
import { Box } from "@mui/material";
import ActionButton from "../../../../components/commonComponents/Buttons/ActionButton";
import SectionsList from "./SectionsList";
import NewWorkspaceSection from "./NewWorkspaceSection";
import { Add } from "@mui/icons-material";


const ImpressionsWorkspace = () => {
    const currentStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();
    const [newSectionPopup, setNewSectionPopup] = React.useState(false);
    const showNewSectionButton = typeof currentStateData.workspace_report_sections !== "undefined" && currentStateData.workspace_report_sections !== null && currentStateData.workspace_report_sections.length > 0 ? currentStateData.workspace_report_sections.filter(sec => sec.type === "impression").length === 0 : true;

    return (
        <>
            <Box height={10} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                Per workspace (i.e., root company) only one Impressions section can be added. Impressions sections are automatically published by the system once the data was processed the first time based on the settings defined here.
            </StyledBlackInformationTypography>
            <Box height={5} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0 }}>
                Changes made here apply across the entire workspace.
            </StyledBlackInformationTypography>
            <Box height={2} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                Impressions sections cannot be archived or removed. Adding a new Impressions section is only possible if there is no impressions section added yet for a workspace (i.e., root company).
            </StyledBlackInformationTypography>
            <Box height={2} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0 }}>
                Important: For the automated publishing of Impressions sections to work, there must be an impressions section added for all workspaces (i.e., root companies).
            </StyledBlackInformationTypography>
            <Box height={10} />

            {
                showNewSectionButton === true &&
                <ActionButton
                    onClick={(e) => {
                        e.preventDefault();
                        setNewSectionPopup(true);
                    }}
                    label={"New Section"}
                    icon={<Add />}
                />
            }


            {/* --------- workspace sections list ----------- */}
            <Box height={10} />
            <SectionsList listType={"available"} sectionType={"impression"} />

            {/* --------- new section popup ----------- */}
            {
                newSectionPopup === true && (
                    <NewWorkspaceSection
                        showModal={newSectionPopup}
                        sectionType={"impression"}
                        usedFor="add"
                        closeModal={() => {
                            setNewSectionPopup(false);
                        }}
                    />
                )
            }

        </>
    );
};

export default ImpressionsWorkspace;
